import React from "react";
import "./ApprovalStatusInfo.css";

const ApprovalStatusInfo = ({ department, period }) => {
  if (!department || !department.approvers || department.approvers.length === 0) {
    return null; // Нейтральный статус - не показываем
  }

  // Определяем общий статус
  const statuses = department.approvers.map((a) => a.status);
  const hasRejected = statuses.some((s) => s === "Отклонено");
  const hasPending = statuses.some((s) => s === "На рассмотрении");
  const allApproved = statuses.every((s) => s === "Согласован");

  let overallStatus = "На рассмотрении";
  let statusIcon = "⏳";
  let statusColor = "#ff9800";

  if (hasRejected) {
    overallStatus = "Отклонено";
    statusIcon = "✗";
    statusColor = "#f44336";
  } else if (allApproved) {
    overallStatus = "Согласован";
    statusIcon = "✓";
    statusColor = "#4caf50";
  } else if (hasPending) {
    overallStatus = "На рассмотрении";
    statusIcon = "⏳";
    statusColor = "#ff9800";
  }

  // Находим комментарий отклонения (если есть)
  const rejectedApprover = department.approvers.find(
    (a) => a.status === "Отклонено"
  );
  const rejectionComment = rejectedApprover?.comment || "";

  return (
    <div className="approval-status-info">
      <div className="approval-status-info__header">
        <span className="approval-status-info__icon">📄</span>
        <span className="approval-status-info__title">
          Зарплата для этого периода уже отправлена на согласование
        </span>
      </div>
      <div className="approval-status-info__content">
        <div className="approval-status-info__row">
          <span className="approval-status-info__label">Статус:</span>
          <span
            className="approval-status-info__status"
            style={{ color: statusColor }}
          >
            <span className="approval-status-info__status-icon">
              {statusIcon}
            </span>
            {overallStatus}
          </span>
        </div>
        {department.initiator && (
          <div className="approval-status-info__row">
            <span className="approval-status-info__label">Инициатор:</span>
            <span className="approval-status-info__value">
              {department.initiator}
            </span>
          </div>
        )}
        <div className="approval-status-info__row">
          <span className="approval-status-info__label">Согласующие:</span>
          <span className="approval-status-info__value">
            {department.approvers
              .map((a) => `${a.name}`)
              .join(", ")}
          </span>
        </div>
        {hasRejected && rejectionComment && (
          <div className="approval-status-info__row approval-status-info__row--comment">
            <span className="approval-status-info__label">Комментарий:</span>
            <div className="approval-status-info__comment">{rejectionComment}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApprovalStatusInfo;

